import React from "react";
import ReactDOM from "react-dom/client";
import {AppRoute} from "./route";
import "./css/glob.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <AppRoute></AppRoute>
    </React.StrictMode>
);
